import React from 'react';
import { Stethoscope } from 'lucide-react';
import DirectoryManager from '@/components/DirectoryManager';

export default function InhouseConsultantsPage() {
  return (
    <DirectoryManager
      config={{
        title: 'In-house Consultants',
        subtitle: 'Consultants working within the hospital. Only active consultants appear in the referral entry form.',
        icon: <Stethoscope className="w-6 h-6" />,
        entitySingular: 'Consultant',
        entityPlural: 'Consultants',
        apiPath: '/inhouse-consultants',
        extraField: {
          key: 'specialty',
          label: 'Department / Specialty',
          placeholder: 'e.g. Cardiology',
        },
        testIdPrefix: 'consultant',
      }}
    />
  );
}
